import "./ConnectWithUs.module.css";
import Header from "@/reusable_sections/Header";
import GetInTouch from "./sections/GetInTouch";
import CommonQuestions from "./sections/CommonQuestions";
import Footer from "@/reusable_sections/Footer";
export default function ConnectWithUsPage() {
  return <div>
      <Header />
      <GetInTouch />
      <CommonQuestions />
      <Footer />
    </div>;
}